exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-toolbar mat-form-field.contract-state {\n  font-size: 60%;\n  width: 100px;\n  margin-right: 20px; }\n\nmat-slide-toggle {\n  margin-top: 12px; }\n\nmat-expansion-panel-header mat-slide-toggle {\n  margin-top: 0;\n  margin-left: 8px; }\n\nmat-expansion-panel-header mat-icon {\n  margin-right: 8px; }\n\ndiv.mat-input-suffix {\n  margin-left: 6px !important; }\n\nmat-panel-title mat-error {\n  margin-left: 20px; }\n\nmat-table.items-table .mat-cell.actions {\n  max-width: 80px;\n  text-align: right; }\n\nimg.qr {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/ContractDetailComponent/contract-detail.component.scss
// module id = ../../../../../src/ContractsModule/ContractDetailComponent/contract-detail.component.scss
// module chunks = main